module.exports = __webpack_public_path__ + "static/media/nopermission.195ba74b.gif";